// extracted by mini-css-extract-plugin
export default {"form":"SearchInputCI_form__uyp+2","icon":"SearchInputCI_icon__JEbfE","input":"SearchInputCI_input__2IIKj","close":"SearchInputCI_close__lfxZf"};